import React, { FC } from 'react'
import { ControllerRenderProps } from 'react-hook-form'
import compact from 'lodash/compact'
import AutocompleteBase from 'transfix-ui/components/AutocompleteBase'
import { TInputChangeHandler } from 'transfix-ui/components/AutocompleteBase/hooks'
import { useAutocompleteQuery } from 'transfix-ui/components/AutocompleteBase/hooks/useAutocompleteQuery'
import { IAutocompleteBaseOption } from 'transfix-ui/components/AutocompleteBase/types'
import { useSearchTrailersQuery } from '../graphql/SearchTrailers'

export interface ITrailerAutocompleteProps extends ControllerRenderProps {
  carrierId: string
  trackingMethod?: string
  AutocompleteProps?: Omit<
    React.ComponentProps<typeof AutocompleteBase>,
    'options' | 'defaultValue' | 'onChange' | 'value'
  >
  dataTest?: string
}

export const TrailerAutocomplete: FC<ITrailerAutocompleteProps> = ({
  AutocompleteProps = {},
  carrierId,
  onChange,
  value,
  dataTest,
}) => {
  const { options = [] } = useAutocompleteQuery(
    useSearchTrailersQuery,
    {
      variables: { carrierId, searchTerm: value || '' },
    },
    {
      getOptionsConfig: data => {
        const { searchTrailers: result } = data || {}
        const { edges } = result || {}
        const trailers = compact(edges?.map(edge => edge?.node))

        return {
          options: trailers,
          groupIndex: 1,
          optionType: 'withIconAndDescription',
          mapOption: trailer => {
            if (trailer.shipment?.id) {
              return {
                id: trailer.id,
                text: trailer.number,
                description: `(Assigned to #${trailer.shipment?.id})`,
              }
            }
            return { id: trailer.id, text: trailer.number }
          },
        }
      },
    }
  )
  const inputHandler: TInputChangeHandler = (event, selectedItem) => {
    if (event !== null) onChange(selectedItem)
  }
  const optionSelectedHandler = ({ text }: IAutocompleteBaseOption) => text === value

  return (
    <AutocompleteBase
      {...AutocompleteProps}
      clearOnBlur={false}
      autoSelect={false}
      options={options}
      data-test={dataTest}
      onInputChange={inputHandler}
      isOptionEqualToValue={optionSelectedHandler}
      inputValue={value}
    />
  )
}
